import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-dialog-accept-alternative-bid',
  templateUrl: './dialog-accept-alternative-bid.component.html',
  styleUrls: ['./dialog-accept-alternative-bid.component.scss']
})
export class DialogAcceptAlternativeBidComponent implements OnInit {

  minutes: number = 10;
  finishDate: string;
  constructor(
    private dialogRef: MatDialogRef<DialogAcceptAlternativeBidComponent>,
  ) { }

  ngOnInit() {
  }

  @HostListener('window:keyup.esc')
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickConfirm(): void{
    this.finishDate = moment(new Date()).add(this.minutes, "minutes").format();
    this.dialogRef.close(this.finishDate);
  }

}
